<template>
	<AsiDialogFormLayout :title="$t('item.replaceItem')" :icon="icons.clone"
	                     :open="open" :loading="loading" :valid="valid" :errors="errors"
	                     @save="requestSave" @cancel="cancel" unwrapped scrollable>
		<v-card-text class="pa-0">
			<v-form v-model="valid">
				<div class="pa-6">
					<v-row>
						<v-col>
							<ItemNumberAutocompleteInputPaginated v-model="model.replacedById" clearable keepSearch
							                       :label="$t('item.singular')" :placholder="$t('item.singular')"/>
						</v-col>
					</v-row>
				</div>
			</v-form>
		</v-card-text>
	</AsiDialogFormLayout>
</template>

<script lang="ts">
	import {Component, Emit, Prop, Watch} from 'vue-property-decorator';
	import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
	import AsiSelect from "@/components/common/AsiSelect";
	import ItemUpdateReplacedBy from "@/models/item/ItemUpdateReplacedBy";
	import {IItemAdmin, IItemAdminListEntry} from "@/models/item/ItemAdminModels";
	import ItemListFilterAdmin from "@/models/item/ItemListFilterAdmin";
	import AsiAutocomplete from "@/components/common/AsiAutocomplete";
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import ItemAutocompleteInput from "@/components/item/admin/ItemAutocompleteInput.vue";
	import AsiListTableOptions from "@/components/common/AsiListTableOptions";
	import ItemNumberAutocompleteInputPaginated from "@/components/item/admin/ItemNumberAutocompleteInputPaginated.vue";
	import AsiCardDetail from "@/components/common/AsiCardDetail.vue";

	@Component({
		components: {
			AsiCardDetail,
			ItemNumberAutocompleteInputPaginated, ItemAutocompleteInput, AsiAutocomplete, AsiSelect, AsiDialogFormLayout}
	})
	export default class ItemUpdateDialogReplacedBy extends AsiDialogForm {

		@Prop({type: Object, required: true})
		public item!: IItemAdmin;

		private model: ItemUpdateReplacedBy | null = null;
		private filterModel: ItemListFilterAdmin = new ItemListFilterAdmin();
		private optionsModel: AsiListTableOptions = new AsiListTableOptions();
		private filteredList: IItemAdminListEntry[] = [];

		private setItemInternal(): void {
			if (this.model === null){
				this.model = new ItemUpdateReplacedBy(this.item);
			} else {
				this.model.setDetailModel(this.item);
			}
		}

		private itemValue(item: IItemAdminListEntry): string | null {
			return item.itemNumber;
		}

		private loadItems(): void {
			this.loading = true;

			this.optionsModel.itemsPerPage = 10;
			this.filterModel.itemNumber = this.model?.replacedById ?? null;

			this.$itemServiceAdmin.items(this.filterModel, this.optionsModel)
				.then(res => this.filteredList = res.data);
		}

		@Emit('cancel')
		public cancel(event: Event): Event {
			this.setItemInternal();
			const form = this.$refs.form as HTMLFormElement;
			this.reset([], form);
			return event;
		}

		@Watch('item', {deep: true, immediate: true})
		private onItemChanged(): void {
			this.setItemInternal();
		}

		@Emit('save')
		public save(): void {
			return;
		}

		@Emit('change')
		private change() {
			return;
		}

		private requestSave(): void {
			this.loading = true;

			if (this.model === null) return;

			this.$itemServiceAdmin.updateReplacedBy(this.item.id, this.model)
				.then(this.save)
				.catch(this.handleErrors)
				.finally(() => this.loading = false);
		}


	}
</script>

<style scoped lang="scss">

</style>
